<template>
  <el-select
    filterable
    :clearable="clearable"
    default-first-option
    :filter-method="filterMethod"
    @focus="focusBrand"
    @change="changeBrand"
    :size="size"
    :value="value"
    style="width: 100%"
    :placeholder="placeholder"
    :multiple="multiple"
    :multiple-limit="multipleLimit"
    :collapse-tags="collapseTags"
    :disabled="disabled"
  >
    <el-option
      v-for="(item, index) in brandList"
      :key="item.value"
      :value="item.value"
      :label="item[label]"
      :disabled="item.disabled"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  name: "BrandSelect",
  props: {
    size: String,
    value: [String, Number, Array],
    data: {
      type: Array,
      required: true,
    },
    placeholder: String,
    clearable: Boolean,
    multiple: Boolean,
    multipleLimit: Number,
    collapseTags: Boolean,
    disabledIds: Array,
    disabled: Boolean,
    label: {
      type: String,
      default: "label",
    },
  },
  data() {
    return {
      brandList: [],
    };
  },
  watch: {
    data() {
      this.init();
    },
    value(val) {
      this.sliceData(val);
    },
  },
  methods: {
    init() {
      this.sliceData(this.value);
    },
    changeBrand(val) {
      this.$emit("input", val);
      this.$emit("change", val);
    },
    filterMethod(query) {
      if (query) {
        const data = [];
        this.data.filter((item) => {
          const name = `${item.label}`.toUpperCase();
          const str = query.toUpperCase();
          if (name === str) {
            data.unshift(item);
            return true;
          }
          if (name.startsWith(`${str} / `)) {
            data.unshift(item);
            return true;
          }
          // if (name.startsWith(str) && data.length < 200) {
          if (name.indexOf(str) >= 0 && data.length < 200) {
            data.push(item);
            return true;
          }
          if (this.multiple && (this.value || []).includes(item.value)) {
            return true;
          }
          if (!this.multiple && this.value === item.value) {
            return true;
          }
          return false;
        });
        this.brandList = this.checkDisabled(data);
      } else {
        this.sliceData(this.value);
      }
    },
    focusBrand() {
      this.sliceData(this.value);
    },
    sliceData(val) {
      if (!this.data) {
        return;
      }
      let brandList = this.data.slice(0, 200);
      if (this.multiple) {
        brandList = brandList.concat(
          (val || [])
          .filter(v => !brandList.some(b => b.value === v))
          .map((v) => {
            return this.data.filter((item) => {
              if (item.value === v) {
                return true;
              }
              return false;
            })[0];
          })
        );
      } else if (val && !brandList.some(b => b.value === val)) {
        brandList = brandList.concat(
          this.data.filter((item) => {
            if (item.value === val) {
              return true;
            }
            return false;
          })
        );
      }
      this.brandList = this.checkDisabled(brandList);
    },
    checkDisabled(list) {
      return list.map(item => ({
        ...item,
        disabled: this.disabledIds ? this.disabledIds.indexOf(item.value) > -1 : false,
      }))
    },
  },
};
</script>
